<template>
  <div class="slider">
    <input
      type="range"
      class="slider-input"
      :value="value"
      :class="[direction]"
      :max="max"
      :min="min"
      :step="step"
      @change="handleChange"
      @input="handleInput"
    >
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    direction: {
      type: String /* horizontal | vertical */,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', Number(event.target.value))
    },
    handleChange (event) {
      this.$emit('change', Number(event.target.value))
    }
  }
}
</script>

<style lang="stylus" scoped>
$gray = #c1c1c1
.slider {
  user-select: none
  width: 135px
  height: 135px
  display: flex
  align-items: center
  justify-content: center
}

.horizontal  {
  transform: rotate(-90deg)
  transform-origin: center center
}
.vertical {

}
.slider-input {
  -webkit-appearance: none
  width: 130px
  height: 30px
  outline: none
  opacity: 0.7
  cursor: pointer
  background: linear-gradient(to top, transparent, transparent 40%, #c1c1c1 40%, #c1c1c1 60%, transparent 60%);
  transition: opacity .2s
  &:hover {
    opacity: 1
  }
}
.slider-input::-webkit-slider-thumb {
  -webkit-appearance: none
  appearance: none
  width: 15px
  height: 15px
  cursor: pointer
  border: 1px solid $gray
  border-radius: 50%
  background: $gray
}
.slider::-moz-range-thumb {
  width: 15px
  height: 15px
  cursor: pointer
  border: 1px solid $gray
  border-radius: 50%
  background: $gray
}
</style>
